import styled from 'styled-components';

export const Container = styled.div`
  background: var(--white-dark);
  padding: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;

  div .leaflet-control-container > div:first-child {
    right: 20px !important;
    left: auto !important;
  }

  .leaflet-tooltip {
    border-radius: 8px !important;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

export const Button = styled.div`
  width: 100%;
  height: 60px;
  color: var(--white);
  background: var(--primary);
  border: 0;
  border-radius: 20px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  font-weight: 500;
  font-size: 18px;
  cursor: pointer;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BackButton = styled.div`
  width: 50px;
  height: 50px;
  color: var(--white);
  background: var(--black-transparent);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  border: 0;
  border-radius: 25px;
  cursor: pointer;
  outline: none;
  position: absolute;
  left: 20px;
  top: 10px;
  z-index: 1001;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Wrapper = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 1002;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 40px 10%;
  }
`;

export const ExternalButton = styled.a`
  width: 170px;
  height: 50px;
  background: var(--black-transparent);
  color: var(--white);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  border: 0;
  border-radius: 25px;
  cursor: pointer;
  outline: none;
  position: absolute;
  left: 50%;
  right: 50%;
  bottom: 20px;
  transform: translate(-50%);
  z-index: 1001;

  display: flex;
  justify-content: center;
  align-items: center;
`;
